export const NAV = {
  root: "wedding-nav",
  logoLink: "nav-logo-link",
  links: {
    story: "nav-link-story",
    details: "nav-link-details",
    schedule: "nav-link-schedule",
    gallery: "nav-link-gallery",
    stay: "nav-link-stay",
    rsvp: "nav-link-rsvp",
    registry: "nav-link-registry",
    faq: "nav-link-faq",
    contact: "nav-link-contact",
    parking: "nav-link-parking",
    inspiration: "nav-link-inspiration",
    admin: "nav-link-admin",
  },
  rsvpCta: "nav-rsvp-cta",
  mobileToggle: "nav-mobile-toggle",
  langEn: "nav-lang-en",
  langEt: "nav-lang-et",
};

export const HERO = {
  section: "hero-section",
  names: "hero-names",
  date: "hero-date",
  location: "hero-location",
  countdown: "hero-countdown",
  scrollCue: "hero-scroll-cue",
};

export const STORY = {
  section: "story-section",
  heading: "story-heading",
  body: "story-body",
};

export const DETAILS = {
  section: "details-section",
  ceremony: "details-ceremony",
  reception: "details-reception",
};

export const SCHEDULE = {
  section: "schedule-section",
  item: (key) => `schedule-item-${key}`,
};

export const GALLERY = {
  section: "gallery-section",
  image: (i) => `gallery-image-${i}`,
};

export const RSVP_FORM = {
  section: "rsvp-section",
  form: "rsvp-form",
  fullName: "rsvp-full-name-input",
  email: "rsvp-email-input",
  attendingYes: "rsvp-attending-yes",
  attendingNo: "rsvp-attending-no",
  guestCount: "rsvp-guest-count",
  plusOneToggle: "rsvp-plus-one-toggle",
  plusOneName: "rsvp-plus-one-name",
  mealTrigger: "rsvp-meal-trigger",
  mealOption: (m) => `rsvp-meal-${m}`,
  songRequest: "rsvp-song-request",
  message: "rsvp-message",
  submit: "rsvp-submit",
  success: "rsvp-success",
  error: "rsvp-error",
};

export const REGISTRY = {
  section: "registry-section",
  card: (key) => `registry-card-${key}`,
  iban: (i) => `registry-iban-${i}`,
  ibanCopy: (i) => `registry-iban-copy-${i}`,
};

export const FAQ = {
  section: "faq-section",
  trigger: (i) => `faq-trigger-${i}`,
};

export const STAY = {
  section: "stay-section",
  card: (key) => `stay-card-${key}`,
};

export const PARKING = {
  section: "parking-section",
  mapLink: "parking-map-link",
  form: "parking-form",
  name: "parking-name-input",
  code: "parking-code-input",
  plate: "parking-plate-input",
  submit: "parking-submit",
  success: "parking-success",
};

export const CONTACT = {
  section: "contact-section",
  email: "contact-email",
  phone: "contact-phone",
};

export const ADMIN = {
  page: "admin-page",
  table: "admin-rsvp-table",
  row: (id) => `admin-rsvp-row-${id}`,
  delete: (id) => `admin-rsvp-delete-${id}`,
  refresh: "admin-refresh",
  stats: {
    total: "admin-stat-total",
    attending: "admin-stat-attending",
    declined: "admin-stat-declined",
    guests: "admin-stat-guests",
  },
};
